// extracted by mini-css-extract-plugin
export default {"cardOffer":"AddProduct_cardOffer__7qlPi","btnOffer":"AddProduct_btnOffer__e0ijG"};